import React from "react";
import { AppRoot } from "tmaui";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { SignPage } from "./pages/SignPage/SignPage";
import { AppsPage } from "./pages/AppsPage/AppsPage";
import "tmaui/tmaui.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppsPage />,
  },
  {
    path: "/sign",
    element: (
      <SignPage
        startParam={new URLSearchParams(window.location.search).get(
          "start_param"
        )}
      />
    ),
  },
  {
    path: "/apps",
    element: <AppsPage />,
  },
]);

export const App = () => (
  <AppRoot>
    <RouterProvider router={router} />
  </AppRoot>
);
